import { useQuery } from "@tanstack/react-query";

import type { IFiltersSelectionDto } from "../../types/dto";
import type { IFiltersSelectionOptions } from "../types";

import { createFilterSelectionQuery } from "./options";

export const useFiltersSelectionQuery = <TData = IFiltersSelectionDto>(options?: IFiltersSelectionOptions<TData>) => {
    return useQuery(createFilterSelectionQuery(options));
};
